import React, { useState, useEffect, useRef } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import priceCalculator from "@heartinz/gst_india_product_price_calculator";
import { CircularProgress } from "@mui/material";

import Messages from "../../../constants/Messages";
import { useShowAlert } from "../../../context/AlertContext";
import { useNetwork } from "../../../context/NetworkContext";
import handleError from "../../../constants/handleError";
import AxiosInstance from "../../../utils/AxiosInstance";
import { usePermission } from "../../../context/PermissionContext";
import uRLs from "../../../utils/baseUtils";
import CustomUnit from "../product/CustomUnit";
import { useAuth } from "../../../context/AuthProvider";
import finance from "@heartinz/finance";
import { AddIcon, CheckIcon, CloseIcon, EditIcon, ErrorCircleIcon, UserIcon } from "../../../constants/Icons";

const AddService = ({
  isActive,
  onClose,
  onAdd,
  onMode = "ADD",
  isBtnLoading,
  loading,
  estimateSuggest,
  serviceNameSuggests,
  addNewServiceName,
  isServiceName = false,
  onAddservice,
  AddServiceBtn = false,
  showQuanity = true,
}) => {
  const [error, setErrors] = useState({});
  const hasFetched = useRef(false);
  const [isServiceData, setServiceData] = useState({
    title: "",
    hsnsac: "",
    description: "",
    serviceByName: "",
    mrp: 0,
    quantity: 1,
    saleprice: 0,
    taxpercentage: 0,
    discount: 0,
    baseprice: 0,
    taxamount: 0,
    isStock: false,
    imode: "SERVICE",
    isLock: "SALEPRICE",
  });
  const { settings } = useAuth();
  const [payloadData, setPayloadData] = useState();
  const [unitData, setUnitData] = useState();
  const [AddUnitopen, setAddUnitopen] = useState(false);
  const [unitSuggest, setUnitSuggest] = useState([]);
  const serviceTitleRef = useRef(null);
  const quanityRef = useRef(null);
  const serviceDescriptionRef = useRef(null);
  const serviceMrpRef = useRef(null);
  const serviceSalepriceRef = useRef(null);
  const serviceTaxpercentageRef = useRef(null);
  const serviceBasepriceRef = useRef(null);
  const estimateSuggestionsRef = useRef(null);
  const buttonRef = useRef(null);

  // FIX #4: two separate ref arrays instead of one shared `suggestionRef`,
  // since the title-suggestions list and the serviceByName-suggestions list
  // both used to write into the same array at the same indices.
  const titleSuggestionRef = useRef([]);
  const serviceNameSuggestionRef = useRef([]);

  const containerRef = useRef(null);
  const serviceNameContainerRef = useRef(null);
  const productHsnsacRef = useRef(null);
  const serviceByNameRef = useRef(null);
  const popupMrpInputRef = useRef(null);
  const [showTitlePopup, setShowtitlePopup] = useState(false);
  const [showServicePopup, setShowServicePopup] = useState(false);
  const [showMrpPopup, setShowMrpPopup] = useState(false);
  const [popupMrpValue, setPopupMrpValue] = useState("");
  const [popupMrpStyle, setPopupMrpStyle] = useState({});
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const [highlightedServiceIndex, setHighlightedServiceIndex] = useState(-1);
  const { checkNetwork } = useNetwork();
  const debounceTimerRef = useRef(null);
  const controllerRef = useRef(null);
  const requestIdRef = useRef(0);

  // FIX #3: single source of truth for "the term the user currently cares about".
  // Any API response that doesn't match this exact term when it resolves is discarded,
  // regardless of how the debounce/abort timing interleaves.
  const activeTermRef = useRef("");

  const [addTolist, setAddToList] = useState(true);

  const [suggestionLoading, setSuggestionLoading] = useState(false);
  const [allSuggestions, setAllSuggestions] = useState([]);
  const [serviceNameSuggestions, setserviceNameSuggestions] = useState([]);
  const [serviceNameSuggest, setServiceNameSuggest] =
    useState(serviceNameSuggests);

  const showAlert = useShowAlert();
  const defaultConversion = settings?.defaultUnits?.find(
    (u) => u?.unitCodeNormalized === unitData?.primaryUnitCode,
  );
  const hasUnit = !!defaultConversion?.unitName;
  const isLocked = isServiceData?.unitLocked;

  const validateForm = () => {
    const errors = {};

    if (!isServiceData.title) {
      errors.title = Messages.ERROR.TITLE_EMPTY;
      serviceTitleRef.current?.focus();
    } else if (
      isServiceData.hsnsac &&
      !/^99\d{4}$/.test(isServiceData.hsnsac)
    ) {
      errors.hsnsac = Messages.ERROR.INVALID_HSN_SAC;
    } else if (
      isServiceData.mrp === undefined ||
      isServiceData.mrp === null ||
      isServiceData.mrp === ""
    ) {
      errors.mrp = Messages.ERROR.MRP_EMPTY;
      serviceMrpRef.current?.focus();
    } else if (
      isServiceData.mrp &&
      !/^\d*\.?\d{0,2}$/.test(isServiceData.mrp)
    ) {
      errors.mrp = Messages.ERROR.INVALID_INPUT;
      serviceMrpRef.current?.focus();
    } else if (
      isServiceData.saleprice === undefined ||
      isServiceData.saleprice === null ||
      isServiceData.saleprice === ""
    ) {
      errors.saleprice = Messages.ERROR.SALEPRICE_EMPTY;
      serviceSalepriceRef.current?.focus();
    } else if (
      isServiceData.saleprice &&
      !/^\d*\.?\d{0,2}$/.test(isServiceData.saleprice)
    ) {
      errors.saleprice = Messages.ERROR.INVALID_INPUT;
      serviceSalepriceRef.current?.focus();
    } else if (
      isServiceData.taxpercentage === undefined ||
      isServiceData.taxpercentage === null ||
      isServiceData.taxpercentage === ""
    ) {
      errors.taxpercentage = Messages.ERROR.TAX_EMPTY;
      serviceTaxpercentageRef.current?.focus();
    } else if (
      isServiceData.taxpercentage &&
      !/^[0-9]*$/.test(isServiceData.taxpercentage)
    ) {
      errors.taxpercentage = Messages.ERROR.INVALID_INPUT;
      serviceTaxpercentageRef.current?.focus();
    } else if (
      isServiceData.discount === undefined ||
      isServiceData.discount === null ||
      isServiceData.discount === ""
    ) {
      errors.discount = Messages.ERROR.DISCOUNT_EMPTY;
    } else if (
      isServiceData.discount &&
      !/^\d*\.?\d{0,2}$/.test(isServiceData.discount)
    ) {
      errors.discount = Messages.ERROR.INVALID_INPUT;
    } else if (
      isServiceData.baseprice === undefined ||
      isServiceData.baseprice === null ||
      isServiceData.baseprice === ""
    ) {
      errors.baseprice = Messages.ERROR.BASEPRICE_EMPTY;
      serviceBasepriceRef.current?.focus();
    } else if (
      isServiceData.baseprice &&
      !/^\d*\.?\d{0,2}$/.test(isServiceData.baseprice)
    ) {
      errors.baseprice = Messages.ERROR.INVALID_INPUT;
      serviceBasepriceRef.current?.focus();
    } else if (
      isServiceData.taxamount === undefined ||
      isServiceData.taxamount === null ||
      isServiceData.taxamount === ""
    ) {
      errors.taxamount = Messages.ERROR.TAXAMOUNT_EMPTY;
    } else if (
      isServiceData.taxamount &&
      !/^\d*\.?\d{0,2}$/.test(isServiceData.taxamount)
    ) {
      errors.taxamount = Messages.ERROR.INVALID_INPUT;
    }

    setErrors(errors);
    if (Object.keys(errors).length > 0) {
      const firstErrorField = Object.keys(errors)[0];
      switch (firstErrorField) {
        case "title":
          serviceTitleRef.current?.focus();
          break;
        case "hsnsac":
          productHsnsacRef.current?.focus();
          break;
        case "mrp":
          serviceMrpRef.current?.focus();
          break;
        case "saleprice":
          serviceSalepriceRef.current?.focus();
          break;
        case "taxpercentage":
          serviceTaxpercentageRef.current?.focus();
          break;
        case "baseprice":
          serviceBasepriceRef.current?.focus();
          break;
        default:
          break;
      }
    }
    return Object.keys(errors).length === 0;
  };

  // FIX #2 (root cause): shared logic for deciding which suggestion source to
  // use for a given title value. Both handleChange and onFocus now call this,
  // so they can never diverge again.
  const refreshTitleSuggestions = (value) => {
    if (value.length > 0) {
      handleSearch(value, (results) => {
        setAllSuggestions(
          (results || []).map((r) => ({ ...r, source: "api" })),
        );
        setHighlightedIndex(-1);
      });
    } else {
      // FIX #3 (empty branch): cancel any pending debounce/in-flight request
      // left over from a previous keystroke, so a stale API response can
      // never land later and overwrite the correct estimate-suggestions list.
      if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
      if (controllerRef.current) controllerRef.current.abort();
      activeTermRef.current = "";
      requestIdRef.current++;

      // FIX #1: guard against estimateSuggest being undefined/null so
      // `.map` is never called on `undefined`.
      const filtered =
        estimateSuggest?.filter((s) =>
          s.title.toLowerCase().includes(value.toLowerCase()),
        ) || [];
      setAllSuggestions(
        filtered.map((r) => ({ ...r, source: "estimate" })),
      );
      setHighlightedIndex(-1);
    }
  };

  const handleChange = (e) => {
    setErrors({});
    const { name, value } = e.target;
    let inputValue = value;

    if (name === "mrp" || name === "saleprice" || name === "baseprice") {
      const regex = /^\d+(\.\d{0,2})?$/;
      if (!regex.test(value)) inputValue = "";
    }

    if (name === "title") {
      inputValue = value.replace(/^\s+/, "").replace(/\s{2,}/g, " ");
      // if (hasModulePermission("SERVICE") || permission === undefined) {
        refreshTitleSuggestions(inputValue);
        setShowtitlePopup(true);
      // }
    }

    if (name === "quantity") {
      if (uRLs.UNIT === "true" && unitData) {
        if (!/^\d*\.?\d{0,3}$/.test(value)) {
          return;
        }
      } else {
        // allow only integer
        if (!/^\d*$/.test(value)) {
          return;
        }
      }
    }

    if (name === "serviceByName") {
      const filtered =
        serviceNameSuggest?.filter((s) =>
          s.serviceByName.toLowerCase().includes(inputValue.toLowerCase()),
        ) || [];
      setserviceNameSuggestions(filtered);
      setHighlightedServiceIndex(-1);
      setShowServicePopup(true);
    }

    if (name === "hsnsac") {
      // allow empty
      if (value === "") {
        inputValue = "";
      } else {
        // exactly 6 digits, starting with 99
        const regex = /^\d{0,6}$/;
        if (!regex.test(value)) {
          return; //  block invalid typing
        }
        inputValue = value;
      }
    }

    if (name === "taxpercentage") {
      const allowedValues = [0, 5, 12, 18, 24];
      const parsedValue = parseInt(value);
      if (isNaN(parsedValue) || !allowedValues.includes(parsedValue)) {
        inputValue = 0;
      } else {
        inputValue = parsedValue;
      }
    }

    const updateData = {
      ...isServiceData,
      [name]: inputValue,
    };
    setServiceData(updateData);
    handleCalculate(updateData);
  };

  // Shared handler for selecting an "estimate" source suggestion, used by
  // both mouse-click and Enter-key paths so behavior can't diverge (FIX #6).
  const selectEstimateSuggestion = (service, nextRef) => {
    if (service?.serviceId) {
      setAddToList(false);
      const updateDate = {
        ...service,
        _id: service?.serviceId,
      };
      openEditModal(updateDate);
    } else {
      setAddToList(true);
      setServiceData((prev) => ({
        ...prev,
        title: service?.title,
        hsnsac: service?.hsnsac,
        taxpercentage: service?.taxpercentage || 0,
        description: service?.description || prev.description, // preserve typed
        imode: "SERVICE",
        isStock: false,
        isLock: "SALEPRICE",
      }));
      setUnitData(service?.unitConfig);
    }
    setShowtitlePopup(false);
    setHighlightedIndex(-1);
    if (nextRef) setTimeout(() => nextRef?.current?.focus(), 0);
  };

  // Shared handler for selecting an "api" source suggestion, used by both
  // mouse-click and Enter-key paths so behavior can't diverge (FIX #6).
  const selectApiSuggestion = (service, nextRef) => {
    setAddToList(true);
    resetForm();
    openEditModal(service);
    setShowtitlePopup(false);
    setHighlightedIndex(-1);
    if (nextRef) setTimeout(() => nextRef?.current?.focus(), 0);
  };

  const handleKeyDown = (e, title, nextRef) => {
    const activeList = allSuggestions;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((prev) => Math.min(prev + 1, activeList.length - 1));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex((prev) => Math.max(prev - 1, 0));
    } else if (e.key === "Enter") {
      e.preventDefault();
      // FIX #5: guard against a stale highlightedIndex pointing past the end
      // of a list that shrank after new suggestions arrived.
      const selected =
        highlightedIndex >= 0 ? activeList[highlightedIndex] : null;

      if (selected) {
        if (selected.source === "estimate") {
          selectEstimateSuggestion(selected, nextRef);
        } else if (selected.source === "api") {
          selectApiSuggestion(selected, nextRef);
        }
      } else {
        if (!title || title.trim() === "") {
          setErrors({ title: Messages.ERROR.TITLE_EMPTY });
          return;
        }
        setShowtitlePopup(false);
        setErrors({});
        nextRef?.current?.focus();
      }
    }
  };

  useEffect(() => {
    if (showMrpPopup && popupMrpInputRef.current) {
      popupMrpInputRef.current.focus();
      popupMrpInputRef.current.select();
    }
  }, [showMrpPopup]);

  const handleEnterFocus = (e, nextRef) => {
    if (e.key === "Enter") {
      e.preventDefault();
      nextRef?.current?.focus();

      if (nextRef === serviceMrpRef) {
        const rect = nextRef.current.getBoundingClientRect();
        setPopupMrpStyle({
          position: "absolute",
          top: `${rect.top + window.scrollY}px`,
          left: `${rect.left + window.scrollX}px`,
          width: `${rect.width}px`,
          zIndex: 10000,
        });
        setPopupMrpValue(isServiceData.mrp);
        setShowMrpPopup(true);
      }
    }
  };

  const handlePaymodeKeyDown = (e) => {
    if (!showServicePopup) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedServiceIndex((prev) =>
        prev < serviceNameSuggestions.length - 1 ? prev + 1 : 0,
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedServiceIndex((prev) =>
        prev > 0 ? prev - 1 : serviceNameSuggestions.length - 1,
      );
    } else if (e.key === "Enter") {
      e.preventDefault();

      if (
        highlightedServiceIndex >= 0 &&
        serviceNameSuggestions[highlightedServiceIndex]
      ) {
        const selectedService = serviceNameSuggestions[highlightedServiceIndex];
        const updatedData = {
          ...isServiceData,
          serviceByName: selectedService.serviceByName,
        };

        setServiceData(updatedData);
        handleService(e, updatedData);
      } else {
        const newService = isServiceData?.serviceByName?.trim();
        if (newService) {
          addNewServiceName(newService);

          const updatedData = { ...isServiceData, serviceByName: newService };
          setServiceData(updatedData);
          handleService(e, updatedData);
        }
      }

      setShowServicePopup(false);
      setHighlightedServiceIndex(-1);
    } else if (e.key === "Escape") {
      setShowServicePopup(false);
      setHighlightedServiceIndex(-1);
    }
  };

  const handleUnit = (payload) => {
    if (!payload) return;
    setUnitData({
      primaryUnitCode: payload?.primaryUnitCode,
    });
    setPayloadData({
      primaryUnitCode: payload?.primaryUnitCode,
    });

    setUnitSuggest((prev) => {
      let updatedStore = [...(prev?.storeUnits || [])];

      const allUnits = [
        ...(prev?.defaultUnits || []),
        ...(prev?.storeUnits || []),
      ];

      const primaryExists = allUnits.some(
        (u) => u.unitCode === payload?.primaryUnitCode,
      );

      if (!primaryExists) {
        updatedStore.push({
          unitName: payload?.primaryUnitName,
          unitCode: payload?.primaryUnitCode,
        });
      }

      if (payload?.secondaryUnitCode) {
        const secondaryExists = allUnits.some(
          (u) => u.unitCode === payload?.secondaryUnitCode,
        );

        if (!secondaryExists) {
          updatedStore.push({
            unitName: payload?.secondaryUnitName,
            unitCode: payload?.secondaryUnitCode,
          });
        }
      }

      return {
        ...prev,
        storeUnits: updatedStore,
      };
    });
  };

  const handlePaymodeKeyDowns = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleService(e);
    }
  };

  const handleCalculate = (updateData) => {
    var { mrp, saleprice, baseprice, taxpercentage, quantity } = updateData;
    let numericMrp = CurrencyConverter.toSubunit(mrp || 0, "INR");
    let numericSaleprice = CurrencyConverter.toSubunit(saleprice || 0, "INR");
    let numericBaseprice = CurrencyConverter.toSubunit(baseprice || 0, "INR");
    let numericTaxpercentage = parseInt(taxpercentage);
    let quanity = Number(quantity || 1);
    let calculationResult;
    let lock = isServiceData.isLock;
    try {
      calculationResult = priceCalculator.getAllPriceList(
        numericMrp,
        numericSaleprice,
        numericBaseprice,
        numericTaxpercentage,
        quanity,
        lock,
      );

      if (lock === "SALEPRICE") {
        if (numericMrp !== calculationResult.mrp) {
          setServiceData((prevData) => ({
            ...prevData,
            mrp: CurrencyConverter.toCurrency(calculationResult.mrp, "INR"),
            discount: CurrencyConverter.toCurrency(
              calculationResult.discount,
              "INR",
            ),
            taxamount: CurrencyConverter.toCurrency(
              calculationResult.gstAmount,
              "INR",
            ),
            baseprice: CurrencyConverter.toCurrency(
              calculationResult.basePrice,
              "INR",
            ),
          }));
        }
        setServiceData((prevData) => ({
          ...prevData,
          discount: CurrencyConverter.toCurrency(
            calculationResult.discount,
            "INR",
          ),
          taxamount: CurrencyConverter.toCurrency(
            calculationResult.gstAmount,
            "INR",
          ),
          baseprice: CurrencyConverter.toCurrency(
            calculationResult.basePrice,
            "INR",
          ),
        }));
      } else if (lock === "BASEPRICE") {
        if (numericMrp !== calculationResult.mrp) {
          setServiceData((prevData) => ({
            ...prevData,
            mrp: CurrencyConverter.toCurrency(calculationResult.mrp, "INR"),
            discount: CurrencyConverter.toCurrency(
              calculationResult.discount,
              "INR",
            ),
            taxamount: CurrencyConverter.toCurrency(
              calculationResult.gstAmount,
              "INR",
            ),
            saleprice: CurrencyConverter.toCurrency(
              calculationResult.salePrice,
              "INR",
            ),
          }));
        }
        setServiceData((prevData) => ({
          ...prevData,
          discount: CurrencyConverter.toCurrency(
            calculationResult.discount,
            "INR",
          ),
          taxamount: CurrencyConverter.toCurrency(
            calculationResult.gstAmount,
            "INR",
          ),
          saleprice: CurrencyConverter.toCurrency(
            calculationResult.salePrice,
            "INR",
          ),
        }));
      }
    } catch (error) {
      showAlert("warning", error.message || Messages.ERROR.INVALID_INPUT);
    }
  };

  const handleService = (event, data) => {
    var quanity = isServiceData.quantity;
    event.preventDefault();
    if (!validateForm()) return;
    const baseData = data || isServiceData;
    const nodata = serviceNameSuggestions.some(
      (it) => it.serviceByName === baseData?.serviceByName,
    );
    if (isServiceName) {
      if (!nodata) {
        addNewServiceName(baseData?.serviceByName?.trim());
      }
    }
    const addData = {
      ...baseData,
      hsnsac: baseData.hsnsac || "",
      mrp: CurrencyConverter.toSubunit(baseData.mrp || 0, "INR"),
      saleprice: CurrencyConverter.toSubunit(baseData.saleprice || 0, "INR"),
      soldprice: CurrencyConverter.toSubunit(baseData.saleprice || 0, "INR"),
      taxpercentage: baseData.taxpercentage || 0,
      discount: CurrencyConverter.toSubunit(baseData.discount || 0, "INR"),
      baseprice: CurrencyConverter.toSubunit(baseData.baseprice || 0, "INR"),
      taxamount: CurrencyConverter.toSubunit(baseData.taxamount || 0, "INR"),
      isLock: baseData.isLock,
      uniqueId: Date.now() + Math.floor(Math.random() * 10000),
      unitConfig: unitData,
    };
    onAdd(addData, quanity, onMode);
  };

  const handleAddService = (event, data) => {
    var quanity = isServiceData?.quantity;
    event.preventDefault();
    if (!validateForm()) return;
    const baseData = data || isServiceData;
    const nodata = serviceNameSuggestions.some(
      (it) => it.serviceByName === baseData?.serviceByName,
    );
    if (isServiceName) {
      if (!nodata) {
        addNewServiceName(baseData?.serviceByName?.trim());
      }
    }
    const addData = {
      ...baseData,
      hsnsac: baseData.hsnsac || "",
      mrp: CurrencyConverter.toSubunit(baseData.mrp || 0, "INR"),
      saleprice: CurrencyConverter.toSubunit(baseData.saleprice || 0, "INR"),
      soldprice: CurrencyConverter.toSubunit(baseData.saleprice || 0, "INR"),
      taxpercentage: baseData.taxpercentage || 0,
      discount: CurrencyConverter.toSubunit(baseData.discount || 0, "INR"),
      baseprice: CurrencyConverter.toSubunit(baseData.baseprice || 0, "INR"),
      taxamount: CurrencyConverter.toSubunit(baseData.taxamount || 0, "INR"),
      isLock: baseData.isLock,
      uniqueId: Date.now() + Math.floor(Math.random() * 10000),
      unitConfig: unitData,
    };

    onAddservice(addData, quanity, onMode);
  };

  const handleSearch = (term, setResults) => {
    if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
    if (controllerRef.current) controllerRef.current.abort();

    // FIX #3: record intent immediately (not inside the timeout), so any
    // in-flight/older response can be checked against the *latest* term the
    // user actually typed, no matter how the timers/aborts interleave.
    activeTermRef.current = term;

    debounceTimerRef.current = setTimeout(async () => {
      try {
        if (!checkNetwork()) return;
        setSuggestionLoading(true);

        const thisController = new AbortController();
        controllerRef.current = thisController;
        const currentId = ++requestIdRef.current;

        const response = await AxiosInstance.get(
          `module/service/search-hybrid?searchtxt=${term}`,
          { signal: thisController.signal },
        );

        // Double guard: request-id AND exact-term match. Either one changing
        // means a newer keystroke has superseded this response.
        if (currentId === requestIdRef.current && term === activeTermRef.current) {
          setResults(response.data.results || []);
        }
      } catch (error) {
        if (error.name !== "CanceledError" && error.name !== "AbortError") {
          handleError(error, showAlert);
        }
      } finally {
        setSuggestionLoading(false);
      }
    }, 200);
  };

  const openEditModal = async (cItem) => {
    try {
      const response = await AxiosInstance.get(`/module/service/${cItem?._id}`);

      if (response?.data?.results) {
        const serviceData = response.data.results;

        setServiceData((prev) => ({
          ...prev,
          ...serviceData,
          description:
            serviceData?.description?.trim() !== ""
              ? serviceData.description
              : prev.description, // preserve if empty
          mrp: CurrencyConverter.toCurrency(serviceData.mrp || 0, "INR"),
          saleprice: CurrencyConverter.toCurrency(
            serviceData.saleprice || 0,
            "INR",
          ),
          discount: CurrencyConverter.toCurrency(
            serviceData.discount || 0,
            "INR",
          ),
          baseprice: CurrencyConverter.toCurrency(
            serviceData.baseprice || 0,
            "INR",
          ),
          taxamount: CurrencyConverter.toCurrency(
            serviceData.taxamount || 0,
            "INR",
          ),
          imode: "SERVICE",
          isStock: false,
        }));
        setUnitData(serviceData?.unitConfig);
      }
    } catch (error) {
      if (error?.response?.status === 404) {
        setServiceData((prev) => ({
          ...prev,
          title: cItem?.title || "",
          imode: "SERVICE",
          isStock: false,
          isLock: "SALEPRICE",
        }));
        setUnitData();
        return;
      }

      console.error("Failed to fetch service details:", error);
      showAlert("error", "Unable to fetch service details");
    }
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const resetForm = () => {
    setServiceData({
      code: "",
      hsnsac: "",
      title: "",
      description: "",
      serviceByName: "",
      quantity: 1,
      mrp: 0,
      saleprice: 0,
      taxpercentage: 0,
      discount: 0,
      baseprice: 0,
      taxamount: 0,
    });
    setErrors({});
  };

  const handleRadioChange = (inputName) => {
    setServiceData((prev) => ({
      ...prev,
      isLock: inputName,
    }));
  };

  const handleUnitClose = () => {
    setAddUnitopen(false);
    if (showQuanity) {
      quanityRef.current.focus();
    } else {
      serviceMrpRef.current.focus();
    }
  };

  useEffect(() => {
    if (!isActive) return;

    if (document.visibilityState !== "visible") return;

    const timer = setTimeout(() => {
      serviceTitleRef.current?.focus();
    }, 120);

    return () => clearTimeout(timer);
  }, [isActive]);

  useEffect(() => {
    if (
      highlightedIndex >= 0 &&
      titleSuggestionRef.current[highlightedIndex]
    ) {
      titleSuggestionRef.current[highlightedIndex].scrollIntoView({
        block: "nearest",
        behavior: "smooth",
      });
    }
  }, [highlightedIndex]);

  useEffect(() => {
    if (
      highlightedServiceIndex >= 0 &&
      serviceNameSuggestionRef.current[highlightedServiceIndex]
    ) {
      serviceNameSuggestionRef.current[highlightedServiceIndex].scrollIntoView({
        block: "nearest",
        behavior: "smooth",
      });
    }
  }, [highlightedServiceIndex]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        estimateSuggestionsRef?.current &&
        !estimateSuggestionsRef?.current?.contains(e.target)
      ) {
        setShowtitlePopup(false);
      }
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setShowtitlePopup(false);
      }
      if (
        serviceNameContainerRef.current &&
        !serviceNameContainerRef.current.contains(e.target)
      ) {
        setShowServicePopup(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleEsc);

    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    setUnitSuggest({
      defaultUnits: settings?.defaultUnits || [],
      storeUnits: settings?.storeUnits || [],
    });
  }, []);

  // FIX #7: removed the render-body console.log(allSuggestions) that was
  // firing on every render/keystroke.

  return (
    <div>
      <div className="modal-backdrop show"></div>
      <div
        className="modal show"
        id="CustomerModal"
        tabIndex="0"
        aria-modal="true"
        role="dialog"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title"> Add Service </h6>
              <button
                type="button"
                onClick={handleClose}
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="row g-3">
                <div className="col-lg-7">
                  <div className="row g-3">
                    <div className="col-lg-8">
                      <label htmlFor="title" className="form-label">
                        Title <span className="text-danger">*</span>
                      </label>
                      <div className="position-relative" ref={containerRef}>
                        <input
                          type="text"
                          className="form-control"
                          name="title"
                          autoComplete="off"
                          ref={serviceTitleRef}
                          value={isServiceData.title}
                          onChange={handleChange}
                          onFocus={() => {
                            setShowtitlePopup(true);
                            // FIX #2: use the exact same source-selection logic
                            // as handleChange, instead of always dumping the
                            // unfiltered/estimate-only list on every focus.
                            refreshTitleSuggestions(isServiceData.title || "");
                          }}
                          onKeyDown={(e) =>
                            handleKeyDown(
                              e,
                              isServiceData.title,
                              productHsnsacRef,
                            )
                          }
                        />
                        {
                        // (hasModulePermission("SERVICE") ||
                        //   permission === undefined) &&
                          showTitlePopup &&
                          (suggestionLoading ? (
                            // FIX (loading gap): show a clear loading state
                            // instead of leaving a stale list on screen while
                            // the debounced API request is in flight.
                            <ul
                              className="suggestions-list"
                              style={{ maxHeight: "150px" }}
                            >
                              <li className="suggestion-item text-muted">
                                Searching…
                              </li>
                            </ul>
                          ) : (
                            allSuggestions.length > 0 && (
                              <ul
                                className="suggestions-list"
                                style={{ maxHeight: "150px" }}
                              >
                                {allSuggestions.map((service, index) => (
                                  <li
                                    key={service?._id || index}
                                    ref={(e) =>
                                      (titleSuggestionRef.current[index] = e)
                                    }
                                    onMouseDown={() => {
                                      // FIX #6: mouse-click now routes through
                                      // the exact same select* helpers as the
                                      // Enter-key path, so the two can never
                                      // behave differently again.
                                      if (service?.source === "estimate") {
                                        selectEstimateSuggestion(
                                          service,
                                          productHsnsacRef,
                                        );
                                      } else if (service?.source === "api") {
                                        selectApiSuggestion(
                                          service,
                                          productHsnsacRef,
                                        );
                                      }
                                    }}
                                    className={`suggestion-item ${
                                      highlightedIndex === index
                                        ? "highlighted"
                                        : ""
                                    }`}
                                  >
                                    {service?.title}
                                  </li>
                                ))}
                              </ul>
                            )
                          ))}
                      </div>
                      {error.title && (
                        <div className="invalid-feedback">{error.title}</div>
                      )}
                    </div>
                    <div className="col-lg-4">
                      <label htmlFor="hsnsac" className="form-label">
                        {" "}
                        HSN/SAC{" "}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="hsnsac"
                        autoComplete="off"
                        ref={productHsnsacRef}
                        onKeyDown={(e) =>
                          handleEnterFocus(e, serviceDescriptionRef)
                        }
                        value={isServiceData?.hsnsac}
                        onChange={handleChange}
                      />
                      {error.hsnsac && (
                        <div className="invalid-feedback">{error.hsnsac}</div>
                      )}
                    </div>
                    <div className="col-lg-12">
                      <label htmlFor="description" className="form-label">
                        Description
                      </label>
                      <textarea
                        type="text"
                        className="form-control"
                        name="description"
                        autoComplete="off"
                        ref={serviceDescriptionRef}
                        value={isServiceData?.description}
                        onChange={handleChange}
                        rows={isServiceName ? 9 : 5}
                      ></textarea>
                      {error.description && (
                        <div className="invalid-feedback">
                          {error.description}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-lg-5">
                  <div className="row g-3">
                    {uRLs.UNIT === "true" && (
                      <div
                        className={
                          showQuanity ? `col-lg-6 col-12` : "col-12 col-lg-6"
                        }
                      >
                        <label htmlFor="unit" className="form-label">
                          Unit{" "}
                          <span
                            className="ms-1"
                            data-bs-toggle="tooltip"
                            data-bs-placement="right"
                            title="Unit cannot be edited once Unit has been added for this Service."
                            style={{ cursor: "pointer", fontWeight: "bold" }}
                          >
                            <ErrorCircleIcon/>{" "}
                          </span>
                        </label>
                        <div className="d-flex align-items-center">
                          <button
                            type="button"
                            className="btn btn-unit fs-10 w-100 d-flex align-items-center justify-content-between"
                            onClick={() => {
                              if (!isServiceData?.unitLocked) {
                                setAddUnitopen(true);
                              }
                            }}
                          >
                            {unitData?.primaryUnitName ? (
                              <>
                                <span>{unitData?.primaryUnitName}</span>
                                {!isLocked && (
                                  <EditIcon iClass={"me-1"}/>
                                )}
                              </>
                            ) : (
                              <>
                                <span>Unit</span>
                                {!isLocked && (
                                  <AddIcon iClass={"me-1"}/>
                                )}
                              </>
                            )}
                          </button>
                        </div>
                        {unitData && (
                          <span>
                            1 {unitData?.primaryUnitCode} ={" "}
                            {unitData?.secondaryUnitCode
                              ? `${unitData?.conversion} ${unitData?.secondaryUnitCode}`
                              : "1 Unit"}
                          </span>
                        )}
                      </div>
                    )}
                    {!showQuanity && <div className="col-6"></div>}
                    {showQuanity && (
                      <div className="col-lg-6">
                        <label htmlFor="quantity" className="form-label">
                          Quanity <span className="text-danger">*</span>
                        </label>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            name="quantity"
                            autoComplete="off"
                            ref={quanityRef}
                            value={isServiceData.quantity}
                            onChange={handleChange}
                            onFocus={(e) => e.target.select()}
                            onKeyDown={(e) => {
                              handleEnterFocus(e, serviceMrpRef);
                            }}
                          />
                          {error.quantity && (
                            <div className="invalid-feedback">
                              {error.quantity}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                    <div className="col-lg-4">
                      <label htmlFor="mrp" className="form-label">
                        {" "}
                        MRP{" "}
                      </label>
                      {!showMrpPopup && (
                        <input
                          type="text"
                          className="form-control"
                          name="mrp"
                          autoComplete="off"
                          ref={serviceMrpRef}
                          value={isServiceData?.mrp}
                          onClick={() => {
                            const rect =
                              serviceMrpRef.current.getBoundingClientRect();
                            setPopupMrpStyle({
                              position: "absolute",
                              top: `${rect.top + window.scrollY}px`,
                              left: `${rect.left + window.scrollX}px`,
                              width: `${rect.width}px`,
                              zIndex: 10000,
                            });
                            setPopupMrpValue(isServiceData.mrp);
                            setShowMrpPopup(true);
                          }}
                          onFocus={(e) => e.target.select()}
                          onChange={handleChange}
                          onKeyDown={(e) =>
                            handleEnterFocus(e, serviceSalepriceRef)
                          }
                        />
                      )}
                      {showMrpPopup && (
                        <input
                          type="text"
                          ref={popupMrpInputRef}
                          value={popupMrpValue}
                          onChange={(e) => {
                            const val = e.target.value;
                            const regex = /^\d+(\.\d{0,2})?$/;

                            if (val === "" || regex.test(val)) {
                              setPopupMrpValue(val);
                              setServiceData((prev) => ({ ...prev, mrp: val }));
                              handleCalculate({ ...isServiceData, mrp: val });
                            }
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              setShowMrpPopup(false);
                              setTimeout(() => {
                                serviceSalepriceRef?.current?.focus();
                              }, 0);
                            }
                          }}
                          onBlur={() => setShowMrpPopup(false)}
                          className="form-control "
                        />
                      )}
                      {error.mrp && (
                        <div className="invalid-feedback">{error.mrp}</div>
                      )}
                    </div>
                    <div className="col-lg-4">
                      <label htmlFor="saleprice" className="form-label">
                        Sale Price <span className="text-danger">*</span>
                      </label>

                      <div className="input-container position-relative">
                        <input
                          type="text"
                          name="saleprice"
                          autoComplete="off"
                          ref={serviceSalepriceRef}
                          value={isServiceData?.saleprice}
                          className="form-control"
                          onFocus={(e) => {
                            e.target.select();
                            if (isServiceData.isLock !== "SALEPRICE") {
                              handleRadioChange("SALEPRICE");
                            }
                          }}
                          onClick={() => handleRadioChange("SALEPRICE")}
                          onKeyDown={(e) =>
                            handleEnterFocus(e, serviceTaxpercentageRef)
                          }
                          style={{ paddingLeft: "30px" }}
                          onChange={handleChange}
                        />
                        <input
                          type="radio"
                          name="selectInput"
                          checked={isServiceData.isLock === "SALEPRICE"}
                          className="position-absolute"
                          style={{
                            top: "50%",
                            left: "10px",
                            transform: "translateY(-50%)",
                            zIndex: 2,
                          }}
                        />
                      </div>
                      {error.saleprice && (
                        <div className="invalid-feedback">
                          {error.saleprice}
                        </div>
                      )}
                    </div>
                    <div className="col-lg-4">
                      <label htmlFor="FisrtName" className="form-label">
                        Tax(%) <span className="text-danger">*</span>
                      </label>
                      <select
                        name="taxpercentage"
                        className="form-select"
                        ref={serviceTaxpercentageRef}
                        value={isServiceData?.taxpercentage}
                        onChange={handleChange}
                        onKeyDown={(e) =>
                          handleEnterFocus(e, serviceBasepriceRef)
                        }
                      >
                        <option value="0">0</option>
                        <option value="5">5</option>
                        <option value="12">12</option>
                        <option value="18">18</option>
                        <option value="24">24</option>
                      </select>
                    </div>
                    <div className="col-lg-4">
                      <label htmlFor="discount" className="form-label">
                        Discount
                      </label>
                      <input
                        readOnly=""
                        type="text"
                        name="discount"
                        autoComplete="off"
                        value={isServiceData?.discount}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-lg-4">
                      <label htmlFor="baseprice" className="form-label">
                        Base Price
                      </label>
                      <div className="input-container position-relative">
                        <input
                          type="text"
                          name="baseprice"
                          autoComplete="off"
                          ref={serviceBasepriceRef}
                          onClick={() => handleRadioChange("BASEPRICE")}
                          onChange={handleChange}
                          onKeyDown={(e) => {
                            if (isServiceName) {
                              handleEnterFocus(e, serviceByNameRef);
                            } else {
                              handlePaymodeKeyDowns(e);
                            }
                          }}
                          value={isServiceData?.baseprice}
                          onFocus={(e) => e.target.select()}
                          className="form-control"
                          style={{ paddingLeft: "30px" }}
                        />
                        <input
                          type="radio"
                          name="selectInput"
                          className="position-absolute"
                          checked={isServiceData.isLock === "BASEPRICE"}
                          style={{
                            top: "50%",
                            left: "10px",
                            transform: "translateY(-50%)",
                            zIndex: 2,
                          }}
                        />
                      </div>
                      {error.baseprice && (
                        <div className="invalid-feedback">
                          {error.baseprice}
                        </div>
                      )}
                    </div>
                    <div className="col-lg-4">
                      <label htmlFor="taxamount" className="form-label">
                        Tax Amount
                      </label>
                      <input
                        readOnly=""
                        type="text"
                        name="taxamount"
                        autoComplete="off"
                        className="form-control"
                        value={isServiceData?.taxamount}
                        disabled
                      />
                    </div>
                    {isServiceName && (
                      <div className="col-lg-12">
                        <label htmlFor="serviceByName" className="form-label">
                          {" "}
                          <UserIcon iClass={"me-1"}/>Service Done
                          By{" "}
                        </label>
                        <div
                          className="position-relative"
                          ref={serviceNameContainerRef}
                        >
                          <input
                            type="text"
                            className="form-control"
                            name="serviceByName"
                            autoComplete="off"
                            ref={serviceByNameRef}
                            onKeyDown={handlePaymodeKeyDown}
                            value={isServiceData?.serviceByName}
                            onChange={handleChange}
                            onFocus={() => {
                              setShowServicePopup(true);
                              const value =
                                isServiceData.serviceByName?.toLowerCase() ||
                                "";
                              const filtered =
                                serviceNameSuggest?.filter((item) =>
                                  item?.serviceByName
                                    ?.toLowerCase()
                                    .includes(value),
                                ) || [];
                              setserviceNameSuggestions(filtered);
                              setHighlightedServiceIndex(-1);
                            }}
                          />
                          {showServicePopup &&
                            serviceNameSuggestions.length > 0 && (
                              <ul
                                className="suggestions-list-top"
                                style={{ maxHeight: "150px" }}
                              >
                                {serviceNameSuggestions.map(
                                  (service, index) => (
                                    <li
                                      key={service?._id || index}
                                      ref={(e) =>
                                        (serviceNameSuggestionRef.current[
                                          index
                                        ] = e)
                                      }
                                      onMouseDown={() => {
                                        setServiceData((prev) => ({
                                          ...prev,
                                          serviceByName: service.serviceByName,
                                        }));
                                        setShowServicePopup(false);
                                        setHighlightedServiceIndex(-1);
                                      }}
                                      className={`suggestion-item ${
                                        highlightedServiceIndex === index
                                          ? "highlighted"
                                          : ""
                                      }`}
                                    >
                                      {service?.serviceByName}
                                    </li>
                                  ),
                                )}
                              </ul>
                            )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer d-block">
              <button
                onClick={handleClose}
                type="button"
                data-bs-dismiss="modal"
                className="btn btn-outline-secondary text-left"
              >
                <CloseIcon iClass={"fs-15"}/> Cancel
              </button>
              {isBtnLoading ? (
                <button className="btn btn-primary pb-0 text-right" disabled>
                  <CircularProgress size={22} className="text-white" />
                </button>
              ) : (
                <button
                  ref={buttonRef}
                  type="button"
                  className="btn btn-primary text-right"
                  onClick={handleService}
                >
                  <CheckIcon/> Submit
                </button>
              )}
              {AddServiceBtn &&
                addTolist &&
                (loading?.addServiseList ? (
                  <button className="btn btn-primary pb-0 text-right" disabled>
                    <CircularProgress size={22} className="text-white" />
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn btn-jobcard text-right me-lg-5"
                    onClick={(e) => handleAddService(e)}
                  >
                    <AddIcon/> Add To Service List
                  </button>
                ))}
            </div>
          </div>
        </div>
      </div>
      {AddUnitopen && (
        <CustomUnit
          onclose={() => {
            handleUnitClose();
          }}
          unitSuggest={unitSuggest}
          setUnitSuggest={setUnitSuggest}
          onAdd={handleUnit}
          selectedData={unitData}
          showSecondary={false}
          summitAuto={true}
        />
      )}
    </div>
  );
};

export default AddService;